const DISTANT_DATE = '2999-10-11T18:53:05.000Z'

// eslint-disable-next-line import/prefer-default-export
export { DISTANT_DATE }
